"use client";

import { cn } from "@/lib/utils/general-utils";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";
import { forwardRef } from "react";

export interface LinkProps
  extends
    NextLinkProps,
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof NextLinkProps> {
  children: React.ReactNode;
  className?: string;
  /** @deprecated Use className directly. */
  variant?: string;
  /** @deprecated Use className directly. */
  size?: string;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { className, variant: _variant, size: _size, ...props },
  ref,
) {
  return (
    <NextLink
      ref={ref}
      className={cn(
        "text-primary underline-offset-4 hover:underline transition-colors",
        className,
      )}
      {...props}
    />
  );
});
